export default __webpack_public_path__ + "static/SRC YT25 - Product Specifications & Technical Data-d5d060adaf4a2516b76a7bde336981b0.pdf";